import React from "react";

export function Toggle({ checked, onChange, label, hint, testId }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none" data-testid={testId}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={`mt-0.5 relative w-9 h-5 rounded-full shrink-0 transition-colors ${checked ? "bg-[#73bf44]" : "bg-neutral-700"}`}
      >
        <span className={`absolute top-0.5 left-0 w-4 h-4 rounded-full bg-white transition-transform ${checked ? "translate-x-[18px]" : "translate-x-0.5"}`} />
      </button>
      <span>
        <span className="block text-sm text-white">{label}</span>
        {hint && <span className="block text-xs text-neutral-500 mt-0.5">{hint}</span>}
      </span>
    </label>
  );
}

export function StatCard({ label, value, sub, accent, testId }) {
  return (
    <div className="bg-[#0F0F0F] border border-neutral-800 rounded-2xl p-5" data-testid={testId}>
      <div className="text-[0.65rem] uppercase tracking-[0.16em] text-neutral-500">{label}</div>
      <div className={`font-heading text-3xl font-bold mt-2 ${accent || "text-white"}`}>{value ?? "—"}</div>
      {sub && <div className="text-xs text-neutral-500 mt-1">{sub}</div>}
    </div>
  );
}

export function IconBtn({ children, danger, ...props }) {
  return (
    <button
      {...props}
      className={`inline-flex p-2 rounded-lg text-neutral-400 transition-colors ${
        danger ? "hover:text-red-400 hover:bg-red-500/10" : "hover:text-white hover:bg-white/[0.05]"
      }`}
    >
      {children}
    </button>
  );
}
